import { useId } from "react";
import { Text } from "@primer/react";
import { SearchIcon } from "@primer/octicons-react";
import { ClearableTextInput } from "../ClearableTextInput/ClearableTextInput.jsx";
import { onKey } from "../../lib/shortcuts/onKey.js";
import { shortcutsById } from "../../lib/shortcuts/shortcutRegistry.js";
import { useShortcutBindings } from "../../lib/shortcuts/useShortcutBindings.js";
import "./ListSearch.css";

const listSearchMinimumItems = 5;

export function ListSearch({ ariaLabel, clearLabel, onChange, onClear, placeholder, totalCount, value, visibleCount }) {
  const inputId = useId();
  const shortcut = shortcutsById.get("focus-search");
  const visible = totalCount >= listSearchMinimumItems || Boolean(value.trim());

  useShortcutBindings(window, [
    onKey(shortcut.binding, () => document.getElementById(inputId)?.focus())
  ]);

  if (!visible) return null;
  return <div className="list-search">
    <ClearableTextInput id={inputId} aria-label={ariaLabel} clearLabel={clearLabel} leadingVisual={SearchIcon} shortcutHint={shortcut.keys[0]} placeholder={placeholder} value={value} onChange={onChange} onClear={onClear} />
    <Text>{visibleCount} of {totalCount}</Text>
  </div>;
}

export function ListNoResults({ children, heading }) {
  return <div className="list-no-results"><strong>{heading}</strong><Text>{children}</Text></div>;
}
